<template>
    <div class="feiyi hml_whplt">
        <!-- <swiperList :swiperStyle="{padding: '1.29rem .4rem .5rem',backgroundImage: 'url('+ require('@/assets/img/secondLevelPage/friyiBg.jpg') +')',backgroundSize: '100% 100%'}" :setSwiperNumFlag="true">
            <li
            class="feiyiSlide"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="feiyiSlideClick(index)"
            >
                <img :src="item.thumb">
                <div class="textContent hml_whplt">
                    <h2 class="title">{{ item.title }}</h2>
                    <div class="xian"></div>
                    <ul class="list">
                        <li
                        v-for="(value,ind) in item.keywords.split('|')"
                        :key="ind"
                        >
                            {{ value }}
                        </li>
                    </ul>
                </div>
            </li>
        </swiperList> -->
        <div class="feiyiSwiper swiper-container">
            <ul class="swiper-wrapper">
                <li
                class="swiper-slide"
                v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
                :key="index"
                @click="feiyiSlideClick(index)"
                >
                    <img :src="item.thumb">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() { 
        return {

        }
    },
    mounted(){
        setTimeout(() => {
            const _this = this;
            this.swiper = new Swiper('.feiyiSwiper',{
                slidesPerView: 'auto',//一行显示3个
                slidesPerColumn: 2,//显示2行
                // slidesPerColumnFill : 'column',
                // initialSlide: _this.levelThreeIndex,
            });
        },100);
    },
    methods: {
        feiyiSlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/millenniumDetails");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    }
}
</script>

<style lang="scss" scoped>
.feiyi{
    background: url(../../../assets/img/secondLevelPage/friyiBg.jpg);
    .feiyiSwiper{
        height: 100%;
        padding-top: .92rem;
        /* height: 10rem;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); */
        ul{
            display: flex;
            // align-items: center;
            justify-content: center;
            li{
                width: 3.38rem;
                height: 4.98rem;
                img{
                    height: 100%;
                }
            }
        }
    }
    // padding-top: .92rem;
    /* .feiyiSlide{
        width: 100%;
        height: 2.62rem;
        position: relative;
        overflow: hidden;
        // box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        margin-bottom: .18rem;
        .textContent{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            h2{
                font-size: .5rem;
                color: #fff;
                font-family: "siyuan";
            }
            .xian{
                width: 3.6rem;
                height: .01rem;
                background: #fff;
                margin: .16rem 0;
            }
            .list{
                display: flex;
                li{
                    color: #fff;
                    font-size: .24rem;
                }
            }
            p{
                color: #fff;
                font-size: .24rem;
            }
        }
    } */
}
</style>